module.exports = __webpack_public_path__ + "img/lock.d287ac3a.svg";